import { render, staticRenderFns } from "./NormalSearchNav490.vue?vue&type=template&id=64f026b0&scoped=true"
import script from "./NormalSearchNav490.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav490.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f026b0",
  null
  
)

export default component.exports